var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3704 1.6084V9.76512H18.8371V4.28535L6.96454 16.6939L5.85665 15.6339L17.8091 3.14185L12.9516 3.14206L12.9516 1.60873L20.3704 1.6084ZM3.83333 3.14193C2.56308 3.14193 1.53333 4.17167 1.53333 5.44192V18.1457C1.53333 19.4159 2.56308 20.4457 3.83333 20.4457H16.5371C17.8073 20.4457 18.8371 19.4159 18.8371 18.1457V13.6046H20.3704V18.1457C20.3704 20.2628 18.6542 21.979 16.5371 21.979H3.83333C1.71624 21.979 0 20.2628 0 18.1457V5.44192C0 3.32483 1.71624 1.60859 3.83333 1.60859H10.1852V3.14193H3.83333Z",
    fill: "#A9B6C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.5aeb44dc4ad1ee53f72d4c4a40f90990.svg";
export { ForwardRef as ReactComponent };